import React, { useCallback, useState, createContext, useContext } from 'react';
interface BookingContextValue {
  isOpen: boolean;
  openBooking: () => void;
  closeBooking: () => void;
}
const BookingContext = createContext<BookingContextValue | null>(null);
export function BookingProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const openBooking = useCallback(() => setIsOpen(true), []);
  const closeBooking = useCallback(() => setIsOpen(false), []);
  return <BookingContext.Provider value={{
    isOpen,
    openBooking,
    closeBooking
  }} data-id="element-11">
      {children}
    </BookingContext.Provider>;
}
export function useBooking() {
  const ctx = useContext(BookingContext);
  if (!ctx) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return ctx;
}